import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function ChevronRight({ idVariant = '', className }: Props) {
  return (
    <IconBase name="chevron-right" w={24} className={className}>
      <path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z" fill="currentColor"/>
    </IconBase>
  )
}

export default ChevronRight
